import { Observable } from "rxjs/internal/Observable";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpService } from "../services/http.service";
import { tap } from "rxjs";
import { Router } from "@angular/router";
import { rolesKey } from "src/app/app.const";
import { DataLogin } from "./models/data.login";
import { DataUser } from "./models/data.user";
import { RoleUser } from "./models/role.user";

@Injectable({
	providedIn: "root",
})
export class AuthService {
	constructor(private http: HttpService, private router: Router) {}

	public login(email: String, password: String): Observable<DataLogin> {
		return this.http
			.post(environment.api.login, { email: email, password: password })
			.pipe(
				tap((dataLogin) => {
					if (dataLogin.access_token && dataLogin.status === 1)
						AuthService.setAuthToken(dataLogin);
					else AuthService.removeAuthToken();
					return dataLogin;
				})
			);
	}

	public refresh(): Observable<DataLogin> {
		return this.http.post(environment.api.refresh).pipe(
			tap((dataLogin) => {
				if (dataLogin.access_token && dataLogin.status === 1)
					AuthService.setAuthToken(dataLogin);
				else AuthService.removeAuthToken();
				return dataLogin;
			})
		);
	}

	public recover(email: String) {
		return this.http.post(environment.api.recover, { email: email });
	}

	public async logout() {
		try {
			this.http.post(environment.api.logout).subscribe();
		} catch (error) {}

		this.router.navigate(["/login"], { replaceUrl: true });
		AuthService.removeAuthToken();
	}

	public user(): Observable<any> {
		return this.http.post(environment.api.dataUser).pipe(
			tap((user) => {
				AuthService.setDataUser(user);
				return user;
			})
		);
	}

	public static removeAuthToken() {
		localStorage.removeItem("AuthTokenWeb"+environment.name);
		localStorage.removeItem("dataUserWeb");
		localStorage.removeItem("dataLoginWeb");
		localStorage.removeItem("user");
	}

	public static setAuthToken(dataLogin: DataLogin) {
		if (dataLogin.userData?.establishment?.image)
			dataLogin.userData.establishment.image =
				environment.api.host +
				"public/" +
				dataLogin.userData.establishment.image;
		localStorage.setItem("AuthTokenWeb"+environment.name, dataLogin.access_token);
		AuthService.setDataUser(dataLogin.userData);
		AuthService.setDataLogin(dataLogin);
	}

	public static getAuthToken(): string {
		return localStorage.getItem("AuthTokenWeb"+environment.name);
	}

	public static setDataUser(dataUser: DataUser) {
		if (!dataUser.photo)
			dataUser.photo = "assets/images/icons/no-image-user.svg";
		if (dataUser.establishment && !dataUser.establishment.image)
			dataUser.establishment.image = "assets/images/icons/no-image.svg";
		localStorage.setItem("dataUserWeb", JSON.stringify(dataUser));
	}

	public static getDataUser(): DataUser {
		return JSON.parse(localStorage.getItem("dataUserWeb"));
	}

	public static setDataLogin(dataLogin: DataLogin) {
		dataLogin.generated_at = new Date();
		localStorage.setItem("dataLoginWeb", JSON.stringify(dataLogin));
	}

	public static getDataLogin(): DataLogin {
		return JSON.parse(localStorage.getItem("dataLoginWeb"));
	}

	public static role(): RoleUser {
		const role = new RoleUser();
		role.id = 2;
		role.key = rolesKey.user;

		if (!this.isLogged()) return role;

		role.id = this.getDataUser().role_id;
		switch (this.getDataUser().role_id) {
			// case 1:
			// 	role.key = rolesKey.root;
			// 	break;
			case 1:
				role.key = rolesKey.admin;
				break;
			case 2:
				role.key = rolesKey.user;
				break;
		}

		return role;
	}

	static isLogged() {
		return !!this.getAuthToken();
	}

	static isExpired(): boolean {
		if (!this.isLogged()) return true;
		const token = this.getDataLogin();
		return new Date().getTime() > new Date(token.expires_at).getTime()
			? true
			: false;
	}

	static isTimeToRefresh(): boolean {
		if (this.isLogged()) {
			const token = this.getDataLogin();
			const expires_at = new Date(token.expires_at).getTime();
			const generated_at = new Date(token.generated_at).getTime();
			const time = new Date().getTime();
			const restTime = expires_at - time;
			const compareTime = expires_at - generated_at;

			return restTime <= 0.9 * compareTime;
		}

		return false;
	}

	static get isAdmin(): boolean {
		return AuthService.role().key === rolesKey.admin;
	}

	// static get isRoot(): boolean {
	// 	return AuthService.role().key === rolesKey.root;
	// }

	static get isCustomer(): boolean {
		return AuthService.role().key === rolesKey.user;
	}

	public registerUser(parameters: any): Observable<any> {
		return this.http.post(environment.api.registerUser, parameters);
	}
}
